var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5L6.375 10.875L7.95 9.24375L10.875 12.1687V3H13.125V12.1687L16.05 9.24375L17.625 10.875L12 16.5ZM5.25 21C4.63125 21 4.10175 20.7799 3.6615 20.3396C3.22125 19.8994 3.00075 19.3695 3 18.75V15.375H5.25V18.75H18.75V15.375H21V18.75C21 19.3687 20.7799 19.8986 20.3396 20.3396C19.8994 20.7806 19.3695 21.0007 18.75 21H5.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.08aea066c2b48f11932bad12eda0fc8a.svg";
export { ForwardRef as ReactComponent };